// RoleRedirectRoute.tsx
import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

export const RoleRedirectRoute = () => {
  const { isAuth, isLoading, roles } = useUser();

  if (isLoading) return <div>Loading...</div>;
  if (!isAuth) return <Navigate to="/login" />;
  const isPrivileged =
    roles?.includes("ROLE_ADMIN") || roles?.includes("ROLE_MANAGER");

  return (
    <Navigate
      to={
        isPrivileged
          ? "/dashboard"
          : roles?.includes("ROLE_HR")
            ? "/annualLeave/team"
            : "/my-leave-requests"
      }
      replace
    />
  );
};
